import { ExamEventCourseStatus, RegistrationStatus, RegistrationType } from '@exam-center/graphql';

import { type ExamEvent, type ExamEventCourses, type ExamEventWithCourses } from './types';

export function mapExamEventsAndCourses(
  examEvents: ExamEvent[],
  examEventCourses: ExamEventCourses,
) {
  const examEventCoursesMapByExamEventId = examEventCourses.reduce((acc, examEventCourse) => {
    acc.set(examEventCourse.examEventId, [
      ...(acc.get(examEventCourse.examEventId) ?? []),
      examEventCourse,
    ]);
    return acc;
  }, new Map<string, ExamEventCourses>());

  const examEventWithCourses = examEvents.map((examEvent) => {
    const examEventCoursesOfEvent = examEventCoursesMapByExamEventId.get(examEvent.id) ?? [];

    return {
      ...examEvent,
      examEventCourses: examEventCoursesOfEvent,
    };
  });

  return examEventWithCourses;
}

export function calculateExamDistributionSummary(examEventsWithCourses: ExamEventWithCourses[]) {
  // An exam event is considered unassigned if it has no assigned courses and is not canceled
  const unassignedCount = examEventsWithCourses.filter(
    (examEvent) =>
      examEvent.registrationStatus !== RegistrationStatus.Canceled &&
      !examEvent.examEventCourses.some((examEventCourse) =>
        [ExamEventCourseStatus.Assigned, ExamEventCourseStatus.Allocated].includes(
          examEventCourse.status,
        ),
      ),
  ).length;

  return {
    totalCount: examEventsWithCourses.length,
    unassignedCount,
    publicCount: examEventsWithCourses.filter(
      (examEvent) => examEvent.registrationType === RegistrationType.Public,
    ).length,
    inHouseCount: examEventsWithCourses.filter(
      (examEvent) => examEvent.registrationType === RegistrationType.InHouse,
    ).length,
    cancelCount: examEventsWithCourses.filter(
      (examEvent) => examEvent.registrationStatus === RegistrationStatus.Canceled,
    ).length,
  };
}
